import { useState, useRef } from "react";
import { axiosWithoutHeader } from "../api/axios";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { Grid, TextField } from "@mui/material";
import loader from "../utils/Helper";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";
import "./Login.css";

const FORGET_USERNAME = "/forgotUsername";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const ForgetUsername = () => {
  const emailRef = useRef();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);
  const toast = useRef(null);
  const initialValues = {
    email: "",
  };
  const validate = (values) => {
    const errors = {};

    // Email validation
    if (!values.email) {
      errors.email ="Email is required";
      emailRef.current.focus();
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
      emailRef.current.focus();
    }

    console.log("errorr", errors);
    return errors;
  };
  const handleSubmit = async (e) => {
    loader.isLoading(true);
    try {
      const response = await axiosWithoutHeader.get(FORGET_USERNAME, {
        params: {
          email: formik.values.email,
        },
      });
      if (response.status === 200) {
        setStatus(
          `We have e-mailed your username to ${formik.values.email}`
        );
      }
    } catch (err) {
      emailRef.current.focus();
      setOpen(true);
      setSeverity('error');
      setMessage(err.response.data.error);

    } finally {
      loader.isLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      ...initialValues,
    },
    onSubmit: handleSubmit,

    validate: validate,
  });

  const handleClose = async () => {
    setOpen(false);
  };

  return (
     <div className="bg-color">
            <Snackbar
              open={open}
              autoHideDuration={8000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              TransitionComponent={SlideTransition}
            >
              <Alert
                onClose={handleClose}
                severity= {severity}
                variant="filled"
                sx={{ width: "50%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <div class="page">
              <div class="brand">
                <img
                  src="/newlogo.png"
                  className="logoImage"
                  alt="Logo"
                />
              </div>
      
              <section class="content">
                <div class="hero">
                  <h1>
                    Your Trusted Partner
                    <br />
                    in <span>Tax Solutions</span>
                  </h1>
      
                  <p>
                    Our multidisciplinary team of experienced Chartered Accountants,
                    Advocates, Lawyers and Company Secretaries provides comprehensive
                    solutions.
                  </p>
      
                  <div class="features">
                    <div class="feature">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="10" cy="7" r="4" />
                        <path d="M20 8v6" />
                        <path d="M23 11h-6" />
                      </svg>
                      Expert Team
                    </div>
      
                    <div class="feature">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <rect x="4" y="4" width="16" height="16" rx="2" />
                        <path d="M9 2v4" />
                        <path d="M15 2v4" />
                        <path d="M9 18v4" />
                        <path d="M15 18v4" />
                        <circle cx="12" cy="12" r="3" />
                      </svg>
                      Reliable Platform
                    </div>
      
                    <div class="feature">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        <path d="m9 12 2 2 4-4" />
                      </svg>
                      Secure Access
                    </div>
                  </div>
      
                  <div class="illustration" aria-hidden="true">
                    <img
                      src="/illustration.png"
                      width="475px"
                      height="400px"
                    />
                  </div>
                </div>
      
                <div class="login-card">
                  <h2>Welcome</h2>
      
                  <p class="subtitle">
                    One-stop platform for comprehensive tax solutions
                  </p>
      
                   {status ? (
                     <Alert variant="outlined" severity="success">
                        {status}
                      </Alert>   
                  ) : 
                  (
                   <form onSubmit={formik.handleSubmit}>
                    {1 === 1 && (
                        <div class="input-wrap">
                          <TextField
                            id="email"
                            name="email"
                            label="Email"
                            className="custom-inputField"
                            fullWidth
                            value={formik.values.email}
                            inputRef={emailRef}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            // autoFocus={true}
                            error={Boolean(formik.errors.email)}
                            helperText={formik.errors.email}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </div>
                      )}
      
                    <button type="submit" class="otp-button">
                       FORGOT USERNAME
                    </button>
                  </form>
                  )}
                      
                  <p className="forgot" style={{textDecoration : "none"}}>
                    Back to <Link to="/">Sign in</Link>
                  </p>   
      
                </div>
              </section>
      
              <div class="floating-ball" aria-hidden="true">
                <img
                  src="/ball.png"
                  width="150px"
                  height="150px"
                />
              </div>
              <div class="sparkle" aria-hidden="true"></div>
            </div>
          </div>
  );
};
export default ForgetUsername;
